import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
  selector: 'soft-query-bar-separator',
  imports: [],
  template: `<div class="border-r border-border h-full mr-4"></div>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueryBarSeparatorComponent {}
